import CheckBoxLabelDesc from "./CheckBoxLabelDescription"

export default CheckBoxLabelDesc
